import React from "react";
import SectionHeading from "./sectionHeading";
import { Circle } from "@speedoc/design-assets/build/icons";
import { Remarkable } from "remarkable";
import ButtonLink from "./buttonLink";

const markdown = new Remarkable();

const InlineList = ({ content }) => {
  return (
    <div className="inlineList">
      <SectionHeading title={content.title} subtitle={content.subtitle} />
      <div className="list">
        {content.list.map((item, i) => (
          <div className="item" key={i}>
            <Circle />
            <span dangerouslySetInnerHTML={{ __html: markdown.render(item.text) }} />
          </div>
        ))}
      </div>
      {content.information && <div className="information">{content.information}</div>}
      {(content.buttonText || content.buttonIsDownloadApp) && <ButtonLink content={content} />}
    </div>
  );
};

export default InlineList;
